import ua from 'ua'
import $ from '$'
import bridge from 'bridge'

var map = require('./schemaDefine.json')

function converter (schema) {
  var url
  for (let i = 0; i < map.length; i++) {
    let item = map[i]
    let reg = new RegExp(item.schema)
    if (reg.test(schema)) {
      if (schema.indexOf('piaoniu://') !== -1) {
        schema = schema.substr(10)
      }

      if (ua.isPiaoniu()) {
        if (schema.indexOf('http') == 0) {
          url = 'piaoniu://web?url=' + encodeURIComponent(schema)
        } else {
          url = 'piaoniu://' + schema
        }
      } else if (ua.isPiaoniuMiniProgram()) {
        url = schema.replace(reg, item.mp)
      } else if (ua.isMobile()) {
        url = decodeURIComponent(schema.replace(reg, item.m))
      } else {
        url = 'http://www.piaoniu.com' + schema.replace(reg, item.pc)
      }
      break
    }
  }
  return url || schema
}

converter.jumpTo = function (schema) {
  const url = converter(schema)
  if (ua.isPiaoniu()) {
    bridge.gotoNativeScheme(url)
  } else {
    location.href = url
  }
}

const Converter = require('pn-link-coverter')
const configList = require('./uri-schema-association')
let conv = new Converter(ua.isPiaoniu() ? 'schema' : 'uri', configList)

converter.convertAllLinks = (container) => {
  $(container).find('a').each((i, a) => {
    let $a = $(a)
    let href = $a.attr('href')
  // add schema prefix to pn-link-coverter later
    let dest = conv.convert(href)
    if (ua.isPiaoniu()) {
      const startWithPiaoniu = dest.indexOf('piaoniu://') == 0
      const isWebLink = dest.indexOf('http') == 0
      if (isWebLink) {
        dest = 'piaoniu://web?url=' + encodeURIComponent(href)
      } else if (!startWithPiaoniu){
        dest = 'piaoniu://' + dest
      }
    }
    $a.attr('href', dest)
  })
}

module.exports = converter



// WEBPACK FOOTER //
// ./src/mods/convertSchemaToUrl.js